import { evalCondition } from 'mailup-react-helpers'

export const isBaseConfiguration = (): boolean => {
  return evalCondition('c:IsOfferLight') as boolean
}
